// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes scaleInLeft {
  from {
    transform: scaleX(0);
  }

  to {
    transform: scaleX(1);
  }
}

.scaleInLeft {
  animation-name: scaleInLeft;
  transform-origin: center right;
}`, "",{"version":3,"sources":["webpack://./resources/assets/js/scss/custom-animate/scale_entrances/scaleInLeft.css"],"names":[],"mappings":"AAAA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC","sourcesContent":["@keyframes scaleInLeft {\n  from {\n    transform: scaleX(0);\n  }\n\n  to {\n    transform: scaleX(1);\n  }\n}\n\n.scaleInLeft {\n  animation-name: scaleInLeft;\n  transform-origin: center right;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
